import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from '../Header';

export default function HeaderWithRouter(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = {
        push: (to, state) => navigate(to, { state }),
        replace: (to, state) => navigate(to, { replace: true, state }),
    };

    return (
        <Header
            {...props}
            location={location}
            params={params}
            history={history}
            navigate={navigate}
        />
    );
}
